<template>
  <v-form
    @submit.prevent="maybeLogin"
    v-model="isFormValid"
    class="customer-login-form"
  >
    <v-alert
      v-if="$route.query.loggedOut"
      type="success"
      dense
      text
      class="pa-2 my-2"
      >You've been logged out.</v-alert
    >
    <v-text-field
      v-model="email"
      class="email-input"
      color="deep-orange"
      :label="$route.params.emailHint ? 'Confirm Email' : 'Email'"
      :placeholder="$route.params.emailHint || null"
      large
      autofocus
      :rules="[ValidationRules.requiredString, ValidationRules.emailRule]"
    />
    <v-text-field
      v-model="password"
      class="password-input mt-4"
      color="blue darken-1"
      label="Password"
      large
      :rules="[ValidationRules.requiredString]"
      ref="password"
      :type="showPass ? 'text' : 'password'"
    >
      <template #append>
        <v-icon @click="showPass = !showPass" large>{{
          showPass ? 'mdi-eye' : 'mdi-eye-off'
        }}</v-icon>
      </template></v-text-field
    >
    <div class="text-right mb-2">
      <v-btn small right plain :to="{ name: ForgotPasswordRoute }"
        >Forgot your Password?</v-btn
      >
    </div>
    <v-btn
      color="amber darken-3"
      :disabled="!isFormValid"
      class="white--text"
      :loading="loading"
      depressed
      x-large
      block
      type="submit"
      >Login</v-btn
    >
    <transition name="fade" mode="out-in">
      <div v-if="error" class="red--text my-3">{{ error }}</div>
    </transition>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ValidationRules from '@/constants/ValidationRules'
import { CustomerRoutes } from '@/constants/RouteNames'

export default {
  name: 'LoginEmailPassForm',
  components: {},
  data() {
    return {
      isFormValid: false,
      loading: false,
      error: false,
      email: '',
      password: '',
      showPass: false,
      ValidationRules,
      ForgotPasswordRoute: CustomerRoutes.FORGOT_PASSWORD,
    }
  },
  created() {
    this.email = this.getCustomerEmail || ''
  },
  computed: {
    ...mapGetters('customer', ['getCustomerEmail']),
  },
  methods: {
    ...mapActions('auth', ['customerLogin']),

    async maybeLogin() {
      this.loading = true
      this.error = false
      try {
        let customer = await this.customerLogin({
          email: this.email,
          password: this.password,
        })
        if (customer) {
          if (this.$route.query.verifyEmailPath) {
            this.$router.push({
              path: this.$route.query.verifyEmailPath,
              query: { ...this.$route.query },
            })
          } else {
            let routeName = this.$route.query.next
              ? this.$route.query.next
              : CustomerRoutes.ORDERS_INDEX
            if (this.$route.query.redirect) {
              this.$router.push({ path: this.$route.query.redirect })
            } else {
              this.$router.push({ name: routeName })
            }
          }
        } else {
          this.error = `Your email and password doesn't match our records. Please try again.`
        }
      } catch (error) {
        this.error = `Your email and password doesn't match our records. Please try again.`
      } finally {
        this.loading = false
      }
    }, // maybeLogin
  },
}
</script>
